<template>
	<div id="app">
		<app-header
			v-if="hasHeader" 
			:isRouteChange="isRouteChange"></app-header>
		<router-view />
		<b-modal 
		  	id="close-modal" 
			:hide-footer="true"  
			centered
            title="Sorry, we are closed!"
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close>
            <div class="px-3">
                <store-info	:hasFullTimeTable = "true" />
            </div>
			<b-button 
				v-if="homeUrl"
				:href="homeUrl" 
				target="blank"
				variant="primary"
				class="float-right">
				OK
			</b-button>    
		</b-modal>
	
		<b-modal 
			id="pause-modal"
			:hide-footer="true"  
			centered
			hide-header
			no-close-on-backdrop
			no-close-on-esc
			hide-header-close >
			<b-container fluid>
				<span>Orders have been temporarily paused. Please check back shortly</span>
			</b-container>
		</b-modal>

		<b-modal 
		  	id="error-modal" 
			:hide-footer="true"  
			centered
            title="Warning!"
			no-close-on-backdrop
			:no-close-on-esc="false"
			hide-header-close>

            <div class="px-3">
                <div class="text-center mb-3">
                    <b-icon icon="exclamation-circle" font-scale="4" variant="warning"></b-icon>
                </div>
                <p>Online ordering is offline, please try later.</p>
            </div>

			<b-button 
				variant="primary"
				class="float-right"
				@click="refresh">
				Retry
			</b-button>    
		</b-modal>
	</div>
</template>

<script>
import Header from "@/components/menu/layouts/Header.vue";
import { mapState } from 'vuex'
import moment from 'moment'

import StoreInfo from '@/components/menu/StoreInfo'

export default {
	data(){
		return {
			hasHeader:this.$route.matched.some(record => record.meta.hasHeader),
			isRouteChange:false,
			byPassForClose:false,
			isStoreClose:false,
			pauseOrders:false,
		}
	},
	computed: { 
		...mapState({
			store: 'store'
		}),
		homeUrl(){
			var url = this.store.homeUrl
			if(url){
				var valid = /^(http|https):\/\/[^ "]+$/.test(url);
				if(!valid){
					url = "http://" + url
				}
			}
			return url
		}
	},
	components: {
		"app-header": Header,
		StoreInfo
	},
	beforeCreate() {	
		let bypassRoute = this.$router.resolve({path : window.location.hash.split("#/")[1]}).route
		if(bypassRoute.matched.some(record => record.meta.byPass)){
			return
		}
		let route = this.$store.getters.getRouteFromLocalStorage
		if(route) {
			this.$router.replace({name: route}).catch(()=>{});			
		}
		let props = this.$router.resolve({name: route}).route;
		if(props.matched.some(record => record.meta.requiresAuth)){
			this.$store.dispatch('ifLogin')
			this.$store.dispatch('ifOrderStatus')
				.then(()=>{
					this.$router.replace({name: "Home"}).catch(()=>{});
				})
		}	
	},
	async created() {
		// SJC	
		let { status } = await this.$store.dispatch('initStore', this.$locationIdFromPath)		
		if (status == 'success') {
			// dangerous script
			var previousDay = moment().set({hour:0,minute:0,second:0,millisecond:0}).subtract(1, 'days')
			let today = moment()
			let previousHours = this.store.hours[previousDay.format('dddd').toLowerCase()]   
			var openByLastDay = false			
			previousHours.forEach((hour) => {
				let sT = moment(hour.startTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')			
				let eT = moment(hour.endTime, ['h:ma', 'H:m']).set({second:0, millisecond:0}).subtract(1, 'days')			
				if(!sT.isBefore(eT)){// true means this is in same day even et is in current day
					eT.add(1, 'days')					
					if(moment().isBefore(eT)){
						openByLastDay = true
						return
					}
				}				
			})
			if(openByLastDay){
				console.log("OpenByLastDay", openByLastDay ? "Yes" : "No")
			   return
           }
			var hours = this.store.hours[today.format('dddd').toLowerCase()]	
			
			if(hours === undefined || hours === null ||hours.length === 0){
				this.isStoreClose = true
			}
			var avilable = false
			hours.forEach((hour) => {
				let sT = moment(hour.startTime, ['h:ma', 'H:m']).set({second:0, millisecond:0})		
				let eT = moment(hour.endTime, ['h:ma', 'H:m']).set({second:0, millisecond:0})
				if(!sT.isBefore(eT)){// true means this is in same day even it is in next day
					eT.add(1, 'days')										
				}	
				avilable = sT.isBefore(moment()) && moment().isBefore(eT)					
				if(avilable){
					return
				}														
			})
			console.log("OpenByToday", avilable ? "Yes" : "No")	
			if(avilable) {
				this.$bvModal.hide('error-modal')				
			}else{
				this.isStoreClose = true
			}	
			if(!this.isStoreClose) {
				this.pauseOrders = this.store.pauseOrders;
			}
		} else {
			this.$bvModal.show('error-modal')
		}				
	},
	watch: {
		'$route': {
			deep: true,
            handler() {				
				this.isRouteChange = !this.isRouteChange
				this.hasHeader = this.$route.matched.some(record => record.meta.hasHeader)						
				this.byPassForClose = this.$route.matched.some(record => record.meta.byPassForClose)	
				this.checkStoreOpenStatus()
            }
		},
		isStoreClose(){
			this.checkStoreOpenStatus()
		},
		pauseOrders(){
			this.checkPauseOrderStatus();
		}
	},
	methods: {
		refresh() {
			this.$bvModal.hide('error-modal')
			location.reload()
		},
		checkStoreOpenStatus(){
			if(this.isStoreClose && !this.byPassForClose){
				this.$bvModal.show('close-modal')
			}else{
				this.$bvModal.hide('close-modal')
			}
		},
		checkPauseOrderStatus(){
			if(this.pauseOrders){
				this.$bvModal.show('pause-modal')
			} else {
				this.$bvModal.hide('pause-modal')
			}
		}
	}
};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
	@import '~pretty-checkbox/src/pretty-checkbox.scss';
	@import "@/scss/_main";

</style>